import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

@injectIntl
export default class TableData extends Component {
  static propTypes = {
    children: PropTypes.any,
    th: PropTypes.object,
    intl: PropTypes.object
  }

  render() {
    const { children, th = {}, intl } = this.props
    const label = th.intlKey ? intl.formatMessage({ id: th.intlKey }) : th.label

    return <td data-test={label}>{children}</td>
  }
}
